import React, { useContext } from 'react';
import {
  AuthGate,
  AuthServiceProvider,
  AuthExpiration,
  useAuthState,
  useAuthService
} from '@trp-ta-nitro/auth-react';
import config from '../../config';
import { InternalAuthenticatorContextProvider } from '../../context/InternalAuthenticatorContext/InternalAuthenticatorContext';
import { FlowContext } from '../../core/flow-engine';
import { redirectToAccountFinder } from '../../flows/shared/utils';

// When rendered invokes the refreshToken() method on the useAuthService hook.
export const RefreshAuthToken = () => {
  // access the auth services using useAuthService() hook
  const authService = useAuthService();

  // immediately invoked function to refresh the oauth-token
  (async () => {
    try {
      // invoke the refreshToken() method on the authService to retrieve a new oauth-token cookie.
      await authService?.refreshToken();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  })();

  return null;
};

export const InternalAuthenticatorChild = ({ children }) => {
  const { userId } = useAuthState();
  if (!userId) {
    return null;
  }

  return (
    <InternalAuthenticatorContextProvider userId={userId}>
      <h2 style={{ color: 'red' }}>Associate: {userId} </h2>
      {children}
    </InternalAuthenticatorContextProvider>
  );
};

const InternalAuthenticator = ({ children }) => {
  const { appState } = useContext(FlowContext);
  const associateID = appState?.store?.loadedData?.associateLoginID;

  return (
    <>
      {!associateID ? (
        <AuthServiceProvider
          options={{
            apiKey: config('apiKey'),
            types: {
              internal: {}
            }
          }}>
          <AuthGate
            internalEntitlements={['CLADM_ELEVATED_USERS']}
            unauthorized={redirectToAccountFinder}>
            <InternalAuthenticatorChild>{children}</InternalAuthenticatorChild>
          </AuthGate>

          {/* starts a session expiry timer and renders it's children ONLY when the session is about to expire.
            session expiry time is a configurable prop and would default to 5 mins if not passed */}
          <AuthExpiration>
            <RefreshAuthToken />
          </AuthExpiration>
        </AuthServiceProvider>
      ) : (
        <AuthServiceProvider
          options={{
            apiKey: config('apiKey'),
            types: {
              internal: {}
            }
          }}>
          <InternalAuthenticatorContextProvider userId={associateID}>
            <h2 style={{ color: 'red' }}>Internal Only!!!</h2>
            <h2 style={{ color: 'red' }}>Associate: {associateID} </h2>
            {children}
          </InternalAuthenticatorContextProvider>

          <AuthExpiration>
            <RefreshAuthToken />
          </AuthExpiration>
        </AuthServiceProvider>
      )}
    </>
  );
};

export default InternalAuthenticator;
